import { PositionContextFormValues } from '@/shared/context/PositionContext.tsx';
import { MarketCode } from '@schuettflix/utils';
import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { BusinessCase } from '@schuettflix/interfaces';
import { CustomerInfo } from '@/shared/models/ContextDataModel/interfaces/entities/customer-info.ts';
import { FinanceSettings } from '@/shared/models/ContextDataModel/interfaces/entities/finance-settings.ts';

type ConstructPositionConfigurationParams = {
    formData: Partial<PositionContextFormValues>;
    businessCase: BusinessCase;
    customerInfo: CustomerInfo;
    financeSettings: FinanceSettings[];
    productConfigurations: ProductConfiguration[];
    marketCode: MarketCode;
    platformOrganizationId: number;
};

export function constructPositionConfiguration({
    formData,
    businessCase,
    customerInfo,
    financeSettings,
    productConfigurations,
    platformOrganizationId,
    marketCode,
}: ConstructPositionConfigurationParams) {
    if (!customerInfo || !customerInfo.projectNumber) {
        throw new Error('customer is needed to construct position configuration');
    }

    if (!businessCase) {
        throw new Error('businessCase is needed to construct position configuration');
    }

    if (!formData.validTo || !formData.validFrom || formData.active === undefined) {
        throw new Error('formData is needed to construct position configuration');
    }

    if (productConfigurations.length === 0) {
        throw new Error(`Product configurations are needed to construct position configuration`);
    }

    if (financeSettings.length === 0) {
        throw new Error(`Finance settings are needed to construct position configuration`);
    }

    return {
        projectNumber: customerInfo.projectNumber,
        platformOrganizationId,
        customer: {
            constructionProjectId: customerInfo.constructionProjectId,
            organizationId: customerInfo.organizationId,
            userId: customerInfo.userId,
            manualCostCenter: customerInfo.manualCostCenter,
        },
        businessCase,
        marketCode,
        salesforceOpportunityId: formData.salesforceOpportunityId,
        active: formData.active,
        validFrom: formData.validFrom,
        validTo: formData.validTo,
        note: formData.note,
        financeSettings,
        productConfigurations,
    };
}
